<template>
    <div class="content-info">
        <img src="@/assets/images/by-bg.png" alt="Перевозки Беларусь Россия ПЭК" class="content-info-bg">
        <div class="content-info-wrapper">
            <h1 class="content-info__title">Перевозки Беларусь — Россия:<br> доставка грузов по ЕАЭС под ключ</h1>
            <div class="content-info__calculation">
                <h2 class="content-info__calculation-title">Рассчитать и отправить груз</h2>
                <div class="content-info__calculation-form">
                    <select-input
                        v-model="calculateSumForms.from"
                        class="content-info__calculation-form_input_size"
                        label="Откуда"
                        :options="citiesFrom"
                    />
                    <select-input
                        v-model="calculateSumForms.to"
                        class="content-info__calculation-form_input_size"
                        label="Куда"
                        :options="citiesTo"
                    />
                    <new-default-input-number v-model="calculateSumForms.weight" type="number" label="Вес, кг" class="content-info__calculation-form_input_size" max="20000" />
                    <new-default-input-number v-model="calculateSumForms.volume" type="number" label="Объём, м&sup3;" :decimal-places="2" class="content-info__calculation-form_input_size" max="80" />
                </div>
                <div class="content-info__calculation-info">
                    <button class="content-info__calculation-button" :disabled="hasError" @click.prevent="openContactForm">Отправить заявку</button>
                    <div class="content-info__calculation-info-description-wrapper">
                        <p v-if="!hasError" class="content-info__calculation-info-description" v-html="getPrice"></p>
                        <p v-if="!hasError" class="content-info__calculation-info-description" v-html="getDays"></p>
                        <p v-if="hasError" class="error-message">{{ errorMessage }}</p>
                    </div>
                    <P class="content-info__calculation-info-text">
                        Расчет цены услуг по организации перевозки груза автомобильным транспортом является
                        предварительным. Итоговая цена услуг рассчитывается исходя из фактических габаритов
                        и свойств груза, а также перечня заказанных услуг. Уточнить актуальные тарифы вы можете
                        по телефону +7 (727) 346-77-77 и в отделениях ПЭК</P>
                </div>
            </div>
            <div class="content-info__description">
                <div class="content-info__description-item">
                    <div class="content-info__description-item-icon">
                        <img src="@/assets/images/award.svg" alt="award">
                    </div>
                    <div class="content-info__description-item-text">
                        <p class="content-info__description-item-title">25 лет</p>
                        <p class="content-info__description-item-subtitle">На логистическом рынке</p>
                    </div>
                </div>
                <div class="content-info__description-item">
                    <div class="content-info__description-item-icon">
                        <img src="@/assets/images/people.svg" alt="people">
                    </div>
                    <div class="content-info__description-item-text">
                        <p class="content-info__description-item-title">4,5 млн</p>
                        <p class="content-info__description-item-subtitle">Клиентов ежегодно</p>
                    </div>
                </div>
                <div class="content-info__description-item">
                    <div class="content-info__description-item-icon">
                        <img src="@/assets/images/global.svg" alt="global">
                    </div>
                    <div class="content-info__description-item-text">
                        <p class="content-info__description-item-title">300</p>
                        <p class="content-info__description-item-subtitle">Отделений в России и за рубежом</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, computed, onMounted, watchEffect } from 'vue';
import newDefaultInputNumber from '~~/components/Input/NewDefaultInputNumber.vue';
import selectInput from '~~/components/Input/SelectInput.vue';
import { watchDebounced } from '@vueuse/core';
import { getSugggest } from '@/pages/index/utils/getSugggest';
import { getNeedCalculate } from '@/pages/index/utils/getNeedCalculate';
import { useLang } from '~/stores/langStore';
import { useContentPages } from '@/stores/homeStores';
import tariffs from '/upload/tariffs_belarus_01102025.json';

const props = defineProps({
    helpers: {
        type: Object,
    },
    calculateForm: {
        type: Object,
    },
    banners: {
        type: Object,
    },
});

const store = useContentPages();

const openContactForm = () => {
    if (window.dataLayer) {
                window.dataLayer.push({'event': 'calc_by'});
            }
    store.setContentConsultForm(calculateSumForms);
    store.updateStatusContactForm(true);
};

const rateByn = 0.042;

const langStore = useLang();

const shipFromHints = ref([]);
const shipToHints = ref([]);
const transportationRate = ref(null);
const transportationRateLoading = ref(false);
const hasError = ref(false);
const errorMessage = ref('');
let citiesFrom = ref([]);
let citiesTo = ref([]);
let calculateSumForms = reactive({
    from: props.helpers?.city_from || { id: 1, value: 'Минск' },
    fromHidden: true,
    to: props.helpers?.city_to || { id: 2, value: 'Москва Восток' },
    toHidden: true,
    weight: props.helpers?.weight.value || 5,
    volume: props.helpers?.volume.value || 0.01,
});


const getUniqueCityList = (key) => {
    const cities = [...new Set(tariffs.map(item => item[key]))].sort();
    return cities.map((value, index) => ({ id: index + 1, value }));
};

const getTariff = () => {
    hasError.value = false;
    const areFieldsFilled = !!calculateSumForms.volume && calculateSumForms.volume > 0 && !!calculateSumForms.weight && calculateSumForms.weight > 0;

    if (!areFieldsFilled) {
        hasError.value = true;
        switch (langStore.langCode) {
            case 'ru':
                errorMessage.value = 'Для расчета стоимости заполните поля выше';
                break;
            case 'en':
                errorMessage.value = 'To calculate the cost, please fill in the fields above';
                break;
        }
        return null;
    }
    const idTariff = tariffs.findIndex(item => item.from === calculateSumForms.from.value && item.to === calculateSumForms.to.value);

    if (idTariff !== -1) {
        hasError.value = false;
        errorMessage.value = '';
        return tariffs[idTariff];
    } else {
        hasError.value = true;
        switch (langStore.langCode) {
            case 'ru':
                errorMessage.value = 'Данный маршрут не доступен к рассчёту. Попробуйте выбрать другие города Беларуси';
                break;
            case 'en':
                errorMessage.value = 'This route is not available for calculation. Try to choose other cities in Belarus';
                break;
        }
    }
    return null;
};

const getPrice = computed(() => {
    const tariff = getTariff();
    if (!tariff) {
        return '';
    }
    const arrayPrices = [];

    if (tariff) {
        if (calculateSumForms.weight <= 35 && calculateSumForms.volume <= 0.14) {
            if (calculateSumForms.weight <= 1 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do1kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 1 && calculateSumForms.weight <= 3 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do3kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 3 && calculateSumForms.weight <= 5 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do5kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 5 && calculateSumForms.weight <= 15 || calculateSumForms.volume > 0.03 && calculateSumForms.volume <= 0.08) {
                arrayPrices.push(tariff['do15kgDo0.08m3']);
            }
            if (calculateSumForms.weight > 15 && calculateSumForms.weight <= 35 || calculateSumForms.volume > 0.08 && calculateSumForms.volume <= 0.14) {
                arrayPrices.push(tariff['do35kgDo0.14m3']);
            }
        } else {
            arrayPrices.push(tariff['min']);
            if (calculateSumForms.weight > 35 && calculateSumForms.weight <= 100) {
                arrayPrices.push(calculateSumForms.weight * tariff['do100kg']);
            }
            if (calculateSumForms.weight > 100 && calculateSumForms.weight <= 200) {
                arrayPrices.push(calculateSumForms.weight * tariff['do200kg']);
            }
            if (calculateSumForms.weight > 200 && calculateSumForms.weight <= 300) {
                arrayPrices.push(calculateSumForms.weight * tariff['do300kg']);
            }
            if (calculateSumForms.weight > 300 && calculateSumForms.weight <= 400) {
                arrayPrices.push(calculateSumForms.weight * tariff['do400kg']);
            }
            if (calculateSumForms.weight > 400 && calculateSumForms.weight <= 500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do500kg']);
            }
            if (calculateSumForms.weight > 500 && calculateSumForms.weight <= 700) {
                arrayPrices.push(calculateSumForms.weight * tariff['do700kg']);
            }
            if (calculateSumForms.weight > 700 && calculateSumForms.weight <= 1000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do1000kg']);
            }
            if (calculateSumForms.weight > 1000 && calculateSumForms.weight <= 1500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do1500kg']);
            }
            if (calculateSumForms.weight > 1500 && calculateSumForms.weight <= 2000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do2000kg']);
            }
            if (calculateSumForms.weight > 2000 && calculateSumForms.weight <= 2500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do2500kg']);
            }
            if (calculateSumForms.weight > 2500 && calculateSumForms.weight <= 3000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do3000kg']);
            }
            if (calculateSumForms.weight > 3000) {
                arrayPrices.push(calculateSumForms.weight * tariff['ot3000kg']);
            }
            if (calculateSumForms.volume >= 0.14 && calculateSumForms.volume <= 0.4) {
                arrayPrices.push(calculateSumForms.volume * tariff['do0.4m3']);
            }
            if (calculateSumForms.volume > 0.4 && calculateSumForms.volume <= 0.8) {
                arrayPrices.push(calculateSumForms.volume * tariff['do0.8m3']);
            }
            if (calculateSumForms.volume >= 0.8 && calculateSumForms.volume <= 1.1) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.1m3']);
            }
            if (calculateSumForms.volume > 1.1 && calculateSumForms.volume <= 1.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.5m3']);
            }
            if (calculateSumForms.volume > 1.5 && calculateSumForms.volume <= 1.8) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.8m3']);
            }
            if (calculateSumForms.volume > 1.8 && calculateSumForms.volume <= 2.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do2.5m3']);
            }
            if (calculateSumForms.volume > 2.5 && calculateSumForms.volume <= 3.6) {
                arrayPrices.push(calculateSumForms.volume * tariff['do3.6m3']);
            }
            if (calculateSumForms.volume > 3.6 && calculateSumForms.volume <= 5.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do5.5m3']);
            }
            if (calculateSumForms.volume > 5.5 && calculateSumForms.volume <= 7.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do7.5m3']);
            }
            if (calculateSumForms.volume > 7.5 && calculateSumForms.volume <= 10) {
                arrayPrices.push(calculateSumForms.volume * tariff['do10m3']);
            }
            if (calculateSumForms.volume > 10 && calculateSumForms.volume <= 15) {
                arrayPrices.push(calculateSumForms.volume * tariff['do15m3']);
            }
            if (calculateSumForms.volume > 15) {
                arrayPrices.push(calculateSumForms.volume * tariff['ot15m3']);
            }
        }
    }
    const max = Math.round(Math.max(...arrayPrices));
    const priceRub = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0 }).format(max);
    const priceByn = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0 }).format(max * rateByn);

    let priceRubWords = [];
    let currencyByn = '';
    let aboutWord = '';
    switch(langStore.langCode) {
        case 'ru':
            priceRubWords = ['рубль', 'рубля', 'рублей'];
            currencyByn = 'byn';
            aboutWord = 'От ';
            break;
        case 'en':
            priceRubWords = ['rub', 'rub', 'rub'];
            currencyByn = 'byn';
            aboutWord = 'From ';
            break;
    }

    return `${aboutWord} <b>${priceByn} ${currencyByn}</b> / <b>${priceRub} ${declineWord(priceRub, priceRubWords)}</b>`;
});

const declineWord = (number, words) => {
    number = Math.abs(number) % 100;
    const n1 = number % 10;

    if (number > 10 && number < 20) return words[2];
    if (n1 > 1 && n1 < 5) return words[1];
    if (n1 === 1) return words[0];

    return words[2];
};

const getDays = computed(() => {
    const tariff = getTariff();
    if (!tariff) {
        return '';
    }
    const days = tariff['days'];
    let dayWords = [];
    let aboutWord = '';
    switch(langStore.langCode) {
        case 'ru':
            dayWords = ['день', 'дня', 'дней'];
            aboutWord = 'Примерно ';
            break;
        case 'en':
            dayWords = ['day', 'days', 'days'];
            aboutWord = 'About ';
            break;
    }
    return `${aboutWord} <b>${days} ${declineWord(days, dayWords)}</b>`;
});

const checkNeedCalculate = async () => {
    if (calculateSumForms?.from?.value?.trim() === '' || calculateSumForms?.to?.value?.trim() === '') {
        return;
    }
    transportationRateLoading.value = true;
    transportationRate.value = await getNeedCalculate(calculateSumForms.to.value, calculateSumForms.from.value);
    transportationRateLoading.value = false;
};

watchEffect(() => {
    getTariff();
});

watchDebounced(
    () => calculateSumForms.from,
    async value => {
        shipFromHints.value = await getSugggest(value);
    },
    {
        debounce: 200,
    }
);

watchDebounced(
    () => calculateSumForms.to,
    async value => {
        shipToHints.value = await getSugggest(value);
    },
    {
        debounce: 200,
    }
);

onMounted(() => {
    citiesFrom.value = getUniqueCityList('from');
    citiesTo.value = getUniqueCityList('to');
    checkNeedCalculate();
});
</script>

<style scoped>
.error-message {
    color: #E4003C;
    font-size: 14px;
}
.content-info__calculation-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}
.content-info {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 40px 0px;
    overflow: hidden;
}

.content-info-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

.content-info-wrapper {
    position: relative;
    z-index: 1;
    max-width: 1280px;
    padding: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: flex-start;
    width: 100%;

    @media screen and (max-width: 1300px) {
        &:not(.no-padding) {
            max-width: unset;
            padding: 0 16px;
        }
    }
}

.content-info__title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 48px;
    leading-trim: NONE;
    line-height: 60px;
    letter-spacing: 0%;
    color: #FFFFFF;
    margin: 0;
}
.content-info__calculation {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 32px;
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: rgba(95, 124, 151, 0.25);
    width: 100%;
}
.content-info__calculation-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
}
.content-info__calculation-form {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}
.content-info__calculation-form_input_size, .block-input {
    padding: 0;
}
.content-info__calculation-button {
    border-radius: 6px;
    border: none;
    min-width: 193px;
    height: 56px;
    padding: 16px 28px;
    background-color: #E4003C;
    color:#FFFFFF;
}
.content-info__calculation-info {
    display: flex;
    gap: 20px;
}
.content-info__calculation-info-description-wrapper {
    width: 174px;
    height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
}
.content-info__calculation-info-description {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    margin: 0;
}
.content-info__calculation-info-text {
    max-width: 809px;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    margin: 0;
    color: #AAAAAA;
}
.content-info__description {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
}
.content-info__description-item {
    width: 410px;
    display: flex;
    gap: 20px;
    align-items: center;
    border-radius: 20px;
    opacity: 1;
    padding: 24px;
    backdrop-filter: blur(15.699999809265137px)
}
.content-info__description-item-icon {
    padding: 12px;
    border-radius: 8px;
    background: #FFFFFF1A;
}
.content-info__description-item-text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    justify-content: center;
}
.content-info__description-item-title {
    margin: 0;
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    color:#FFFFFF;
}
.content-info__description-item-subtitle {
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color:#FFFFFF;
}

@media screen and (max-width: 1279px) {
    .content-info {
        padding: 40px 16px;
    }

    .content-info__description {
        overflow-x: scroll;
    }

    .content-info__calculation-info-description-wrapper {
        width: auto;
    }

    .content-info__description-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        min-width: 300px;
    }

    .content-info__title {
        font-size: 36px;
        line-height: 46px;
    }

    .content-info__calculation-info {
        flex-wrap: wrap;
    }

    .content-info__calculation-info-text {
        width: 100% ;
    }

    .content-info__description-item-icon {
        width: 36px;
        height: 36px;
        padding: 6px;
    }

    .content-info__calculation-form {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .content-info__calculation {
        gap: 20px;
        padding: 24px;
        width: 100%;
    }

    .content-info__title {
        font-size: 26px;
        line-height: 36px;
    }

    .content-info__calculation-info {
        flex-direction: column;
        align-items: center;
    }

    .content-info__calculation-info-description-wrapper {
        align-items: center;
    }

    .content-info__calculation-button {
        width: 100%;
    }

    .content-info__calculation-form {
        grid-template-columns: 1fr;
        width: 100%;
    }

    .content-info__calculation-info-text {
        width: 100%;
    }
}
</style>